import { StarFilled } from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";
import natash from "./../../home/imgs/natasha.jpg";
import recept from "./../../home/imgs/recept.jpg";
import man from "./../../home/imgs/man.jpg";
import recept2 from "./../../home/imgs/recept2.jpg";

const testimonials = [
  {
    id: 1,
    name: "Natash Abebi",
    image: natash,
    testimonial:
      "I hired Grand Shop developer for their web development services, and I couldn't be happier. They delivered on time, communicated clearly throughout the process, and the final product exceeded my expectations. I felt like they genuinely cared about my business needs.",
  },
  {
    id: 2,
    name: "Frank",
    image: man,
    testimonial:
      "After working with Grand Shop developer on our digital marketing strategy, we saw a 50% increase in website traffic and a 30% boost in conversions within just three months. Their team knows what they're doing!",
  },
  {
    id: 3,
    name: "Uwimabazi",
    image: recept,
    testimonial:
      "What impressed me the most about Grand Shop Rwanda, was their customer service. Whenever I had a question, their support team was quick to respond and went above and beyond to help me. It's rare to find such dedication!",
  },
  {
    id: 4,
    name: "Divine",
    image: recept2,
    testimonial:
      "I’ve worked with several service providers in the past, but [Company Name] stands out for their innovative approach and attention to detail. They provided solutions that no one else even considered, and it made all the difference in our project.",
  },
];

// Testimonial component
const Testimonial = ({ name, testimonial, link, image }) => {
  return (
    <div className="flex flex-col p-4 shadow-lg">
      <p>{testimonial}</p>
      <div className="border border-gray-300 w-3/4 mt-20 mb-[-30px]"></div>
      <div className="flex justify-end">
        <img
          src= {image}
          alt="profile"
          className="w-16 h-16 rounded-full"
        />
      </div>
      <div className="py-8">
        <h1 className="font-semibold ">{name}</h1>
        <h4 className="text-sm">{link}</h4>

        <div className="flex space-x-1 text-customBlue my-4">
          <StarFilled className=" hover:text-[#3A636C]" />
          <StarFilled className=" hover:text-[#3A636C]" />
          <StarFilled className=" hover:text-[#3A636C]" />
          <StarFilled className=" hover:text-[#3A636C]" />
          <StarFilled className=" hover:text-[#3A636C]" />
        </div>
      </div>
    </div>
  );
};

// TestimonialCard component
const TestimonialCard = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-center text-textColor">
        {" "}
        <span className="text-[#3A636C]">Testimonials and</span> Case Studies
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 p-8">
        {testimonials.map((client, index) => (
          <Testimonial
            key={client.id}
            name={client.name}
            testimonial={client.testimonial}
            image={client.image}
            link={client.link}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;
